<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row
      justify="center"
    >
      <v-col class="pa-0">
        <v-card
          class="elevation-5 flex d-flex flex-column"
        >
          <v-card-text class="flex">
            <yandex-map
              style="width: 100%; height: 60vh;"
              :settings="map.settings"
              :coords="map.coords"
              :controls="map.controls"
            >
              <ymap-marker
                :coords="[place.geo_lat, place.geo_lon]"
                marker-id="index"
                :hint-content="place.address"
                :balloon="{header: place.address}"
                marker-type="placemark"
              >
                <div slot="balloon">
                  <p>Адрес: {{ place.address }}</p>
                </div>
              </ymap-marker>
            </yandex-map>
          </v-card-text>
          <v-card-actions>
            <v-btn
              outlined
              color="primary"
              @click="onBack"
            >
              Назад
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { yandexMap, ymapMarker, loadYmap } from 'vue-yandex-maps'
import { JustpayPlace } from "@/views/loyalty/shared/services/justpay-place-service"
import { PlaceClass } from "@/views/loyalty/shared/classes/place_class"

export default {
  name: "UserProfilePlaceView",
  components: { yandexMap, ymapMarker, loadYmap },
  data: () => ({
    justpayPlace: null,
    map: {
      coords: [54.735147, 55.958727],
      settings: {
        apiKey: 'df228d50-f05d-46b7-b2a7-afccf3a31cb3',
        lang: 'ru_RU',
        coordorder: 'latlong',
        version: '2.1',
      },
      controls: ['geolocationControl', 'rulerControl', 'typeSelector', 'zoomControl'],
      clusterOptions: {
        points: {
          clusterDisableClickZoom: true,
          clusterOpenBalloonOnClick: true,
        },
      },
      },
    place: null,
  }),
  async beforeMount () {
    this.justpayPlace = new JustpayPlace()
    this.placeObj = new PlaceClass()
    this.place = await this.getItems()
    console.log('this.place:', this.place)
    this.map.coords = [this.place.geo_lat, this.place.geo_lon]
    console.log('this.map:', this.map)
    // await loadYmap(Object.assign({ debug: true }, this.map))
  },
  async mounted () {

  },
  methods: {
    async getItems () {
      console.log(this.$route.query.id)
      const place = await this.justpayPlace.getPlace(this.$route.query.id) // this.$route.query.id
      this.placeObj.addPlace(place)
      console.log('place:', place)
      return this.placeObj.place
    },
    onBack () {
      this.$router.back()
    }
  }

}
</script>

<style scoped>

</style>
